const CptName = 'ComMainTitle'
function formatData (node) {
  // console.dir(node);
  return {
    data: {
      value: node.innerHTML
    },
    cpt: CptName
  }
}

export default {
  name: 'main_title',
  formatData
}
